module.exports = __webpack_public_path__ + "img/no_data.a673af31.png";